import { Toggle } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import TRUCKLANE_MINIMUM_MODE from '../../enums/trucklane-minimum-mode';
import { labels } from '../../pages/org-settings/smart-award-settings/utils';

const useStyles = createUseStyles({
  toggleWrapper: {
    display: 'flex',
    gap: 32,
  },
});

const ToggleBar = ({ useWeightMinimum, usePalletMinimum, setUseWeightMinimum, setUsePalletMinimum, setTouched, mode }) => {
  const classes = useStyles();

  const handleWeightToggle = () => {
    if (useWeightMinimum) setTouched(true);
    setUseWeightMinimum(!useWeightMinimum);
  };

  const handlePalletToggle = () => {
    if (usePalletMinimum) setTouched(true);
    setUsePalletMinimum(!usePalletMinimum);
  };

  return (
    <div className={classes.toggleWrapper}>
      <Toggle
        disabled={true}
        labelText={
          mode === TRUCKLANE_MINIMUM_MODE.TOTAL_REVENUE ? labels[TRUCKLANE_MINIMUM_MODE.TOTAL_REVENUE] : labels[TRUCKLANE_MINIMUM_MODE.NET_REVENUE]
        }
        value={true}
      />
      <Toggle labelText={'Weight'} onClick={handleWeightToggle} value={useWeightMinimum ? true : false} />
      <Toggle labelText={'Pallets'} onClick={handlePalletToggle} value={usePalletMinimum ? true : false} />
    </div>
  );
};

ToggleBar.propTypes = {
  useWeightMinimum: PropTypes.bool,
  usePalletMinimum: PropTypes.bool,
  setUseWeightMinimum: PropTypes.func,
  setUsePalletMinimum: PropTypes.func,
  setTouched: PropTypes.func,
  mode: PropTypes.string,
};

export default ToggleBar;
